import { ReactNode } from "react";
import { VariantProps, tv } from "tailwind-variants";

const styles = tv({
  variants: {
    rounded: {
      sm: "rounded-sm",
      default: "rounded",
      md: "rounded-md",
      lg: "rounded-lg",
      full: "rounded-full",
    },
    shadow: {
      true: "shadow",
      false: "shadow-none",
    },
    backgroundColor: {
      white: "border-white bg-white",
      gray: "border-gray-light bg-gray-light",
      secondary: "border-secondary bg-secondary",
      transparent: "border-transparent bg-transparent",
      primary: "border-primary/20 bg-primary/5",
    },
    border: {
      true: "border",
    },
    cursorPointer: {
      true: "cursor-pointer",
    },
  },
  defaultVariants: {
    rounded: "default",
    shadow: true,
    backgroundColor: "white",
  },
});

interface IProps {
  rounded?: VariantProps<typeof styles>["rounded"];
  shadow?: VariantProps<typeof styles>["shadow"];
  backgroundColor?: VariantProps<typeof styles>["backgroundColor"];
  border?: VariantProps<typeof styles>["border"];
  children: ReactNode;
  additionalClassName?: string;
  onClick?: () => void;
}

const Card = ({
  rounded,
  shadow,
  backgroundColor,
  border,
  children,
  additionalClassName,
  onClick,
}: IProps) => {
  return (
    <div
      className={styles({
        rounded,
        shadow,
        backgroundColor,
        border,
        className: additionalClassName,
        cursorPointer: !!onClick,
      })}
      onClick={onClick}>
      {children}
    </div>
  );
};

export default Card;
